import {
    each as _each,
    extend as _extend,
    get as _get,
    head as _head,
    isUndefined as _isUndefined,
    mapValues as _mapValues,
    tail as _tail,
    throttle as _throttle
} from "lodash";

import { AMPLITUDE_EVENTS } from "../../../amplitude";
import ExternalLogger from "../../../logger/ExternalLogger";

import headerEvents from "./events/CoreHeaderEvents";

const throttledHeaderFactoryQuery = _throttle((query, ...args) => query(...args), 1000, {
    trailing: true
});

/**
 *  Deprecated Feb. 17, 2021 - Please make updates in react version
 *
 */

const HeaderController = function (
    $rootScope,
    $scope,
    $http,
    $window,
    $location,
    $cookies,
    $controller,
    $q,
    $timeout,
    HeaderFactory,
    PrimaryPlanTxnAccessSvc,
    AuthenticationStatusService,
    AcctsCustomizationRetrievalService,
    DefaultAcctsCustRetrievalService,
    LogoutService,
    adviceService,
    $anchorScroll,
    MobileMenuService,
    MenuService,
    accountService,
    LegacyService,
    PreventNavigationService,
    eventBus,
    AccuCodeService,
    MenuNavigationFactory,
    headerPlanMessagingDelegate,
    $state
) {
    const logger = ExternalLogger.getInstance("HeaderController");

    $scope.summaryOfAllAccounts = accountService?.getSummaryOfAllAccounts();

    //$scope.styleEnv = getStyleEnv ? getStyleEnv() : __styleEnv__; /* from stylesheet.js*/
    $scope.styleEnv = __styleEnv__;
    $scope.$location = $location;
    $scope.txnAccess = {};
    $scope.userProfile = {};
    $scope.authenticationStatus = {};
    $scope.relativeBaseURL = $window.location.href.substring(
        0,
        $window.location.href.indexOf("/#/")
    );
    $rootScope.currentDomainUrl = $scope.relativeBaseURL.substring(
        0,
        $scope.relativeBaseURL.lastIndexOf("/")
    );
    $rootScope.domainURL = $scope.domainURL = $scope.relativeBaseURL;
    $rootScope.retirementIncomeUrl = $scope.retirementIncomeUrl =
        "/participant/home/#/dashboard/retirement-income";
    $rootScope.participantAppURL = $scope.participantAppURL = "/participant/accounts";
    $rootScope.loginAppURL = $scope.loginAppURL = "/participant";
    $rootScope.advicePage = "/participant/home/#/advice";
    $scope.educationCenterUrl = "";
    $scope.accuLogoAltAttribute = "site logo"; // default value, gets set by accu code
    $scope.advice = {
        dataLoaded: false
    };
    $scope.txnAccessServiceData = {
        loaded: false
    };
    $scope.accuLogoLoaded = false;
    $scope.accu = AccuCodeService.getAccuCode();
    // $scope.accuLogoClass = 'empower-logo';
    // $scope.accuLogo = 'assets/images/EMPOWER_rgb_logo.svg';
    // $scope.accuLogoPNG = 'assets/images/EMPOWER_rgb_logo.png';
    $scope.accuCustomization = {};
    $scope.planMessagingSlides = [];
    let authenticated = false;
    let partialAuth = false;
    $rootScope.isIncompleteModalExist = false;

    $scope.homeClickHandler = function (event) {
        // same function as used in the NavMenuDirective
        event.preventDefault();
        if (PreventNavigationService.isPreventUrl()) {
            PreventNavigationService.preventNavigation(event, "LIAT_LOGO", $scope);
        } else {
            const url = $location.url();

            let transition = true;
            const statesToCheck = [
                // we don't want to re-route and refresh the page if we are already at LIAT
                "/retirement-income",
                "/health-care-costs",
                "/how-do-i-compare",
                "/plan-balances"
            ];

            let re;
            const leading = /^.*/;
            const noTrailingSlash = /[^/]*$/;

            for (let i = 0; i < statesToCheck.length; i++) {
                re = new RegExp(leading.source + statesToCheck[i] + noTrailingSlash.source);
                if (re.test(url)) {
                    transition = false;
                    break;
                }
            }

            // check WNLIAT setting
            if (!$scope.txnAccess.liatEnabled) {
                transition = false;
            }

            if (transition) {
                //DEFC-19724 - user should be prompted to 'stay' if in NQ enrollment.
                //a simple window.location prevent the state change logic.
                if (
                    $state.current &&
                    $state.current.name &&
                    $state.current.name.indexOf("nqEnrollment") > -1
                ) {
                    $state.go("landing.liat");
                } else {
                    $window.location.href =
                        $location.protocol() +
                        "://" +
                        $location.host() +
                        $rootScope.retirementIncomeUrl;
                }
            }
        }
    };

    $scope.jumpTo = function (id) {
        $location.hash(id);
        $anchorScroll();
    };

    $scope.accountsDetailsLoaded = false;

    function getPlanMessages() {
        return headerPlanMessagingDelegate.getMessagesList().then(function (slides) {
            $scope.planMessagingSlides = [...slides];
        });
    }

    function processAuthentication(data) {
        const method = "processAuthentication()";

        logger.debug("{0}- Enter method.", [method]);

        const KeepaliveController = $controller("KeepaliveController as KeepaliveController", {
            $scope: $scope
        });

        _extend($scope.authenticationStatus, _mapValues(data, propertyToBoolean));
        authenticated = _get($scope, "authenticationStatus.authenticated", authenticated);
        partialAuth = _get($scope, "authenticationStatus.partialAuth", partialAuth);

        if (authenticated) {
            logger.debug("{0}- User is authenticated. Call HeaderFactory.", [method]);

            throttledHeaderFactoryQuery(HeaderFactory.query, {}, function (data) {
                $scope.userProfile.data = data;
            });

            logger.debug("{0}- Call KeepaliveController.init().", [method]);
            KeepaliveController.init();

            //login-ui does NOT want nor require any of this.
            // @See LoginUIMasterController where 'showNonAuthHeader' is set.
            if (!$rootScope.showNonAuthHeader) {
                const params = {
                    txnCode: "WNLIAT,WNAMAS,WNFESS,WNCHAL,WNDNPS,WNWLNS"
                };
                // Retrieve the profile list
                PrimaryPlanTxnAccessSvc.query(params).then(function ({
                    WNLIAT,
                    WNAMAS,
                    WNFESS,
                    WNCHAL,
                    WNDNPS,
                    WNWLNS
                }) {
                    angular.extend($scope.txnAccess, {
                        liatEnabled: WNLIAT,
                        advisoryServiceEnabled: WNAMAS,
                        financialEngineSSOEnabled: WNFESS,
                        changeAllocationsEnabled: WNCHAL,
                        dnpSSOEnabled: WNDNPS,
                        wellnessEnabled: WNWLNS
                    });
                    $scope.txnAccessServiceData.loaded = true;

                    getPlanMessages();
                });

                let activeGroupAcctIsTRSPlan = false;
                //---- commented out -- logger.debug("{0}-  Calling setActiveGroupAccount()", [method]);
                MenuService.setAccountDetailsLoaded(false);
                logger.debug("{0}-  Calling setPrimaryGroupAccount()", [method]);
                //--- commented out -- accountService.setActiveGroupAccount()
                accountService
                    .setPrimaryGroupAccount()
                    .then(function () {
                        //---- commented out -- logger.debug("{0}--   got activeGroupAccount. gaId={1}. About to call accountService.setAccountDetails()", [method, accountService.getActiveGroupAccount().groupId]);
                        logger.debug(
                            "{0}--   got primaryGroupAccount. gaId={1}. About to call accountService?.setAccountDetails() with primary plan.",
                            [method, accountService?.getPrimaryGroupAccount()?.groupId]
                        );
                        return accountService?.setAccountDetails(
                            accountService?.getPrimaryGroupAccount()
                        );
                    })
                    .then(function (acctDetails) {
                        logger.debug("{0}--   got account details.", [method]);
                        if (_get(acctDetails, "groupDetails.irsrlCode") === "TRS") {
                            logger.debug("{0}--    Account is TRSPlan.", [method]);
                            activeGroupAcctIsTRSPlan = true;
                        }
                        //Advice link logic
                        if (!activeGroupAcctIsTRSPlan) {
                            /*
                             *
                             logger.debug("{0}--    Account is not TRSPlan. About to call adviceService.init() with isLiatFlow=false, usePrimaryPlanContext=true ", [method]);
                            adviceService.init(isLiatFlow, usePrimaryPlanContext).then(function() {
                                logger.debug("{0}--     after adviseService.init(). Setting values for variables", [method]);

                             */
                            logger.debug(
                                "{0}--    Account is not TRSPlan. About to call adviceService.getGuidanceHeaderInfo() ",
                                [method]
                            );
                            adviceService.getGuidanceHeaderInfo().then(function () {
                                logger.debug(
                                    "{0} adviceService.getGuidanceHeaderInfo() has executed. Now populating data",
                                    [method]
                                );
                                $scope.advice.dataLoaded = adviceService.guidanceHeaderDataLoaded;
                                $scope.advice.managedAccountsAllowed =
                                    adviceService.managedAccountsAllowed;
                                if (adviceService.alreadyEnrolled) {
                                    $scope.advice.alreadyEnrolled = true;
                                    if (adviceService.feEnabled) {
                                        $scope.advice.onGuidanceClick = function () {
                                            MobileMenuService.toggle(false);
                                            adviceService.navigateFE();
                                        };
                                    } else if (adviceService.ibbotsonEnabled) {
                                        $scope.advice.onGuidanceClick = function () {
                                            MobileMenuService.toggle(false);
                                            adviceService.navigateIbbotson();
                                        };
                                    }
                                } else {
                                    $scope.advice.alreadyEnrolled = false;
                                    $scope.advice.onGuidanceClick = function (
                                        guidanceHeaderButton
                                    ) {
                                        MobileMenuService.toggle(false);

                                        const hasMTGNoAll =
                                            adviceService.individualOptions
                                                .doMoneyTypeGroupingsApply &&
                                            !adviceService.individualOptions.hasAllMoneyTypeGroup;
                                        const notEligibleIndicators =
                                            !adviceService.managedAccountsOptions
                                                .eligibleForManagedAccounts &&
                                            !adviceService.managedAccountsOptions.eligibleForAdvice;
                                        if (hasMTGNoAll && notEligibleIndicators) {
                                            //has MTGs but not ALL & is not eligible for MA or Advice.
                                            accountService
                                                .setAccountDetails()
                                                .then(function (accountDetails) {
                                                    $window.location.href =
                                                        $rootScope.participantAppURL +
                                                        "/#/account/" +
                                                        accountDetails.individualId +
                                                        "/" +
                                                        accountDetails.groupId +
                                                        "/investment-options/investment-overview?ignoreDuplicateSets=true";
                                                });
                                        } else if (guidanceHeaderButton) {
                                            //allocations/selection with NO left menu
                                            $window.location.href =
                                                $rootScope.participantAppURL +
                                                "/#/guidance/allocations/selection";
                                        } else {
                                            //allocations/selection with left menu
                                            adviceService.navigateAllocationSelection();
                                        }
                                    };
                                }
                                /*set variable for dynamically assigned Managed Account service provider names */
                                $scope.ManagedAccountsTranslations =
                                    adviceService.ManagedAccountsTranslations;
                                logger.debug("ManagedAccountsTranslations: {0}", [
                                    JSON.stringify($scope.ManagedAccountsTranslations)
                                ]);
                            });
                        }

                        $scope.accountsDetailsLoaded = true;
                    });
            } //end if: (!$rootScope.showNonAuthHeader)
        }

        $scope.$emit("authenticationStatusUpdated", $scope.authenticationStatus);
    }

    function initCustomizations() {
        const method = "initCustomizations()";

        if (
            $window.location.href.indexOf("/npdi") !== -1 ||
            $window.location.href.indexOf("/mfa") !== -1 ||
            $window.location.href.indexOf("/login") !== -1 ||
            $window.location.href.indexOf("/register") !== -1
        ) {
            AuthenticationStatusService.clearCache();
        }

        $q.all([
            AuthenticationStatusService.getAuthData(),
            DefaultAcctsCustRetrievalService.query({}).$promise,
            AcctsCustomizationRetrievalService.query({ accu: $scope.accu }).$promise
        ]).then(function (responses) {
            processAuthentication(_head(responses));
            _each(_tail(responses), setAccuData);
        });
        logger.debug("{0}--   initCustomizations done.", [method]);
        $scope.accuLogoLoaded = true;
    }

    //showNonAuthHeader will only exist for LOGIN-UI
    // @See LoginUIMasterController where 'showNonAuthHeader' is set.
    if (_isUndefined($rootScope.showNonAuthHeader)) {
        initCustomizations();
    } else {
        // LOGIN-UI which may log out a participant due to the state being displayed (/login, etc..)
        //  In this case, this logic is intended to delay "initCustomizations" until after it is determined
        //  if the participant should be logged out.
        $rootScope.$on("loginAuthStatusVerified", initCustomizations);
    }

    $scope.logout = function (e) {
        e.preventDefault();
        if (PreventNavigationService.isPreventUrl()) {
            PreventNavigationService.preventNavigation(e, "LOGOUT", $scope);
        } else {
            eventBus.dispatch(headerEvents.LOGOUT, this);
            $scope.authenticationStatus = {};
            $scope.$emit("authenticationStatusUpdated", $scope.authenticationStatus);

            sessionStorage.removeItem("currentMenuState");
            sessionStorage.removeItem("activeNavItems");
            sessionStorage.removeItem("activeMenuRefOnLastState");

            AuthenticationStatusService.getAuthData().then(function (data) {
                $scope.authenticationStatus = _mapValues(data, propertyToBoolean);
            });
        }
    };

    $scope.mainNavToggle = function () {
        eventBus.dispatch(headerEvents.MAIN_TOGGLE, this, {
            open: false
        });
    };
    $scope.guidanceClick = function () {
        eventBus.dispatch(headerEvents.GUIDANCE, this);
    };
    $scope.beneficiaryClick = function () {
        eventBus.dispatch(headerEvents.BENEFICIARY, this);
    };
    $scope.managedClick = function () {
        eventBus.dispatch(headerEvents.MANAGED, this);
    };
    $scope.profileClick = function (e) {
        if (PreventNavigationService.isPreventUrl()) {
            PreventNavigationService.preventNavigation(e, "PROFILE", $scope);
        } else {
            $rootScope.$emit("profileLinkClicked", e);
            eventBus.dispatch(headerEvents.PROFILE, this);
        }
    };
    $rootScope.profileClicked = function () {
        eventBus.dispatch(headerEvents.PROFILE, this);
        $window.location.href =
            $rootScope.loginAppURL + "/#/profile" + "?accu=" + AccuCodeService.getAccuCode();
    };

    $scope.wellnessPageClicked = function () {
        MobileMenuService.toggle(false);
        $window.location.href = $rootScope.participantAppURL + "/#/wellness";
    };

    $scope.accountClick = function () {
        eventBus.dispatch(headerEvents.ACCOUNT, this);
    };

    $scope.accountDropdownMenuClick = function (submenu) {
        const payload = {
            url: $window.location.href,
            title: submenu.displayText
        };
        eventBus.dispatch(headerEvents.ACCOUNT_DROPDOWN_MENU, this, payload);
        eventBus.dispatchAmplitude({
            event_type: AMPLITUDE_EVENTS.SELECT_MENU,
            event_properties: {
                selection: headerEvents.ACCOUNT_DROPDOWN_MENU,
                ...payload
            }
        });
    };

    function propertyToBoolean(val) {
        const booleanState = ["false", "true"].indexOf(val);
        return booleanState >= 0 ? Boolean(booleanState) : val;
    }

    function setAccuData(data) {
        const method = "setAccuData(" + $scope.accu + ")";
        // For demo only, this will be removed once the customization logic is in place
        document.querySelector("body").classList.add($scope.accu.toLowerCase());

        angular.extend($scope.accuCustomization, data);
        $scope.showGenericLogoPrelogin = data.showGenericLogoPrelogin;
        if (authenticated || !($scope.showGenericLogoPrelogin && !authenticated)) {
            $scope.accuLogo = _get($scope, "accuCustomization.logoUrl", "");
            $scope.accuLogoPNG = _get($scope, "accuCustomization.logoUrlpng", "");
            setAccuLogoClass();
        }
        $scope.accuLogoAltAttribute = $scope.accuCustomization.preLoginLogoAltAttribute;

        $scope.educationCenterUrl = $scope.accuCustomization.educationCntrURL;
        logger.debug("educationCenterUrl is {0}", [$scope.educationCenterUrl]);

        authenticated = _get($scope, "authenticationStatus.authenticated", authenticated);
        $scope.showGenericLogoPrelogin = data.showGenericLogoPrelogin;

        $rootScope.faviconIco = $scope.accuCustomization.faviconIco;
        logger.debug("{0}--   favico=[{1}]=[{2}]", [
            method,
            $scope.accuCustomization.faviconIco,
            $rootScope.faviconIco
        ]);

        $rootScope.faviconPng = $scope.accuCustomization.faviconPng;
        logger.debug("{0}--   faviconPng=[{1}]=[{2}]", [
            method,
            $scope.accuCustomization.faviconPng,
            $rootScope.faviconPng
        ]);

        $rootScope.menuItemModalManifest = data.menuItemModalManifest;

        $rootScope.$broadcast("customizationUpdated", $scope.accuCustomization);
        $rootScope.title = data.title;

        //$scope.accuLogoLoaded = true;
    }

    function setAccuLogoClass() {
        $scope.accuLogoClass = $scope.accu.toLowerCase() + "-logo";
    }

    $scope.onViewAllPrevent = null;

    $scope.notificationContinue = function () {
        $scope.onViewAllPrevent = false;
    };

    $scope.prevent = function (e, type) {
        if (PreventNavigationService.isPreventUrl()) {
            PreventNavigationService.preventNavigation(e, type, $scope);
            $scope.onViewAllPrevent = true;
        } else {
            $scope.onViewAllPrevent = false;
        }
    };
};

HeaderController.$inject = [
    "$rootScope",
    "$scope",
    "$http",
    "$window",
    "$location",
    "$cookies",
    "$controller",
    "$q",
    "$timeout",
    "HeaderFactory",
    "PrimaryPlanTxnAccessSvc",
    "AuthenticationStatusService",
    "AcctsCustomizationRetrievalService",
    "DefaultAcctsCustRetrievalService",
    "LogoutService",
    "adviceService",
    "$anchorScroll",
    "MobileMenuService",
    "MenuService",
    "accountService",
    "LegacyService",
    "PreventNavigationService",
    "eventBus",
    "AccuCodeService",
    "MenuNavigationFactory",
    "headerPlanMessagingDelegate",
    "$state"
];
export default HeaderController;
